import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 20C15.76 20 15.53 19.92 15.34 19.75L7.34 12.75C7.12 12.56 7 12.29 7 12C7 11.71 7.12 11.44 7.34 11.25L15.34 4.25003C15.63 3.99003 16.05 3.93003 16.41 4.09003C16.77 4.25003 17 4.61003 17 5.00003V19C17 19.39 16.77 19.75 16.41 19.91C16.28 19.97 16.14 20 16 20Z" fill={ fill || 'currentColor' }/>
    </svg>

);
